export const finance_ui_methods = {
  gate_dot_color(segment) {
    const segment_map = {
      green: '#10855e',
      orange: '#c4580b',
      red: '#be2b20',
      slate: '#9aa9ba'
    };
    const gate_color = Reflect.get(segment_map, segment) || segment_map.slate;
    return gate_color;
  },
  has_open_overlay() {
    const modal_open_flags = [
      this.invoice_modal_open,
      this.budget_modal_open,
      this.override_modal_open,
      this.irregular_modal_open
    ];
    const has_modal_open = modal_open_flags.some(Boolean);
    const has_active_drawer = Boolean(this.active_drawer_key);
    const has_open_overlay = has_active_drawer || has_modal_open;
    return has_open_overlay;
  },
  sync_overlay_state() {
    if (typeof document === 'undefined') {
      return;
    }
    document.body.classList.toggle(
      'finance-overlay-open',
      this.has_open_overlay()
    );
  },
  close_all_modals() {
    this.invoice_modal_open = false;
    this.budget_modal_open = false;
    this.override_modal_open = false;
    this.irregular_modal_open = false;
    this.sync_overlay_state();
  },
  open_drawer(drawer_key) {
    if (!drawer_key) return;
    this.close_all_modals();
    this.active_drawer_key = drawer_key;
    this.sync_overlay_state();
    this.$nextTick(() => {
      const drawer_body = this.$refs.drawerBody;
      if (drawer_body) drawer_body.scrollTop = 0;
    });
  },
  close_drawer() {
    this.active_drawer_key = null;
    this.sync_overlay_state();
  }
};

export const finance_overlay_watch = {
  active_drawer_key() {
    this.sync_overlay_state();
  },
  invoice_modal_open() {
    this.sync_overlay_state();
  },
  budget_modal_open() {
    this.sync_overlay_state();
  },
  override_modal_open() {
    this.sync_overlay_state();
  },
  irregular_modal_open() {
    this.sync_overlay_state();
  }
};

export function finance_mounted() {
  this.sync_overlay_state();
}

export function finance_before_destroy() {
  if (typeof document !== 'undefined') {
    document.body.classList.remove('finance-overlay-open');
  }
}
